import lexique from './lexique';
import users from './users';

export default {
  ...lexique,
  ...users,
};
